import {DnaApi, DnaController$DnaResult} from "../api/generated/dna-rest";
import ApiConfig from "../api/config/api-config";
import {CreateResult} from "../api/generated/lib-rest";
import HttpService from "./http-service";

export interface IDnaService {
    queryDnaResults(animalId: string): Promise<DnaController$DnaResult[]>;

    upload(animalId: string, file: any): Promise<CreateResult>;
}

// manual API impl until generator supports file uploads and blob responses
class ExtendedDnaApi extends DnaApi {

    public async upload(animalId: string, file: any): Promise<CreateResult> {
        const url = new URL('/animals/' + animalId + '/dna', this.config.host);

        const formData = new FormData();
        formData.append("file", file);

        const response = await HttpService.getAxiosClient().post(
            url.toString(),
            formData,
            {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            });
        return response.data
    }

}

export class DnaServiceImpl implements IDnaService {
    constructor(private readonly dnaApi: ExtendedDnaApi) {
    }

    async queryDnaResults(animalId: string): Promise<DnaController$DnaResult[]> {
        const result = await this.dnaApi.getDnaResult(animalId);
        return result.items;
    }


    public async upload(animalId: string, file: any): Promise<CreateResult> {
        return await this.dnaApi.upload(animalId, file);
    }
}

const apiConfig = new ApiConfig();
const dnaApi = new ExtendedDnaApi(apiConfig);

export const DnaService: IDnaService = new DnaServiceImpl(dnaApi);
